<div>
	{{ x }} {{y}} {{zone}}
	<span *ngIf=height>{{height}}m</span>
</div>

